import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  dd: string;
  dt: string;
}

export const ListCell = ({ ...props }: Props) => {
  return (
    <Styled>
      <dt>{props.dt}:</dt>
      <dd>{props.dd}</dd>
    </Styled>
  );
};

const Styled = styled.dl`
  display: flex;
  font-size: 12px;
  dt {
    color: ${StyleConfig.COLOR.TEXT_GRAY};
  }
`;
export default ListCell;
